module.exports = __webpack_public_path__ + "static/media/tenancy-details.6b4a5f8b.svg";